import Swiper from 'swiper';

export default {
  init() {
    //header dropdown
    $('.header__dropdown-li').on('mouseover', function () {
      $(this).children().next().addClass('open');
      window.addEventListener('scroll', function () {
        $('.header__dropdown').removeClass('open');
      });
    });
    $('.header__dropdown-li').on('mouseleave', function () {
      $('.header__dropdown').removeClass('open');
    });

    //burger
    $('.header__burger').click(function () {
      $('.mobile-nav').addClass('mobile-active');
      $('.header__burger').addClass('burger-active');
      $('html, body').addClass('bodyoff');
    });
//close
    $('.mobile-nav__close').click(function () {
      $('.mobile-nav').removeClass('mobile-active');
      $('.header__burger').removeClass('burger-active');
      $('html, body').removeClass('bodyoff');
    });
//accordion
    $('.mob-accordion-link').click(function (e) {
      e.preventDefault();
      $(this).toggleClass('chevron-active');
      $(this).next('.mob-accordion').slideToggle();
    });
//accordion product Categories
    $('.categories-accordion-link').click(function (e) {
      e.preventDefault();
      $(this).toggleClass('chevron-active');
      $(this).next('.cat-accordion').slideToggle();
    });


    new Swiper('.article-slider-init', {
      slidesPerView: 1,
      spaceBetween: 25,
      loop: true,
      pagination: {
        clickable: true,
        el: '.swiper-article-pagination',
      },
      breakpoints: {
        575: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 25,
        },
        1374: {
          slidesPerView: 4,
          spaceBetween: 25,
        },
      },
    });

    new Swiper('.featured-products-slider-init', {
      slidesPerView: 1,
      spaceBetween: 25,
      loop: true,
      pagination: {
        clickable: true,
        el: '.swiper-featured-products-pagination',
      },
      breakpoints: {
        575: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 25,
        },
        1374: {
          slidesPerView: 4,
          spaceBetween: 25,
        },
      },
    });
  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};
